import React, { FunctionComponent, RefObject } from 'react'
import { UseFormSetValue } from 'react-hook-form'

import { ICustomer } from '../../../../../Customer/interfaces/ICustomer'
import { CustomerList } from '../CustomerList'

import { UserInputDropdown, UserInputDropdownContentWrapper } from './style'

interface IProps {
  searchInput: string
  customerList: ICustomer[]
  filteredResults: ICustomer[]
  setSearchInput: (customerName: string) => void
  setVisible: (state: false) => void
  setValue: UseFormSetValue<any>
  dropdownRef: RefObject<HTMLDivElement>
  isVisible: boolean
}

export const FilterDropdown: FunctionComponent<IProps> = ({
  isVisible,
  searchInput,
  customerList,
  filteredResults,
  setSearchInput,
  setVisible,
  setValue,
  dropdownRef,
}) => {
  const filterCustomers: ICustomer[] =
    searchInput.length > 1 ? filteredResults : customerList

  if (!isVisible) {
    return null
  }

  return (
    <UserInputDropdown ref={dropdownRef}>
      <UserInputDropdownContentWrapper>
        <CustomerList
          customerList={filterCustomers}
          setSearchInput={setSearchInput}
          setVisible={setVisible}
          setValue={setValue}
        />
      </UserInputDropdownContentWrapper>
    </UserInputDropdown>
  )
}
